import { css } from "styled-components";
var HIDE_COMPONENT_OFFSET_TOP = 300;
var TRANSITION_IN_FUNCTION = "cubic-bezier(0.1, 0.7, 0.6, 1)";
var TRANSITION_OUT_FUNCTION = "linear";
var TRANSITION_DURATION = 400;
export var commonStylesForHideTopNav = css([
    "transition-property:top;transition-duration:",
    "ms;"
], TRANSITION_DURATION);
// We need to inline this to avoid the entire styled component being recalculated, causing flickers and other unwanted side effects
export var inlineTransitionStylesForHideTopNav = function() {
    var shouldRetainOriginalPosition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, topOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, hideComponentOffsetTop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : HIDE_COMPONENT_OFFSET_TOP;
    return {
        top: shouldRetainOriginalPosition ? topOffset : "-".concat(hideComponentOffsetTop, "px"),
        transitionDuration: "".concat(hideComponentOffsetTop / HIDE_COMPONENT_OFFSET_TOP * 400, "ms"),
        transitionTimingFunction: shouldRetainOriginalPosition ? TRANSITION_IN_FUNCTION : TRANSITION_OUT_FUNCTION
    };
};
